import { useQuery } from "@tanstack/react-query";
import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import { useParams } from "react-router-dom";
import ky from "ky";

const queryKeyBase = "ddc-api-account";

const url = `/landing/nxlambda/account`;

interface useGetAccountProps {
  accountId?: string;
}

export const useGetAccountId = () => {
  const { dealer: dealerFromParams } = useParams();
  return dealerFromParams;
};
const staleTime = 600000; // 10 mins
export function useGetAccount({ accountId }: useGetAccountProps = {}) {
  const dealerFromParams = useGetAccountId();
  const accountIdToUse = accountId || dealerFromParams;

  return useQuery({
    queryKey: [queryKeyBase, { accountIdToUse }],
    enabled: !!accountIdToUse,
    queryFn: () => fetchAccountGet({ accountId: accountIdToUse }),
    staleTime
  });
}

const fetchAccountGet = ({ accountId }: { accountId?: string }) => {
  if (!accountId) {
    throw new Error("No accountId provided");
  }
  return ky.get(`${url}/${accountId}`).json<AccountEntity>();
};
